<template>
  <div v-loading="formLoading" class="fourthStep">
    <el-form
      ref="extForm"
      :model="{ extForm }"
      :rules="tableRules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
        <el-table
          @row-click="getRow"
          border
          :data="extForm"
          class="ccui-form-child-table"
          max-height="99999"
        >
          <!-- width="150px" -->
          <el-table-column width="150px" prop="formType" label="甲方">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.firstParty`"
                :rules="tableRules.firstParty"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.firstParty"
                  placeholder="请输入"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column width="150px" prop="titleName" label="中交内外部">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.zjInternalExternal`"
                :rules="tableRules.zjInternalExternal"
              >
                <el-radio-group
                  v-model="scope.row.zjInternalExternal"
                  label="是否外贸分包商："
                >
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column width="150px" prop="titleName" label="合同名">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.concName`"
                :rules="tableRules.concName"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.concName"
                  placeholder="请输入"
                  clearable
                  maxlength="255"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            width="150px"
            prop="titleName"
            label="合同金额（万元）"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.concAmount`"
                :rules="tableRules.concAmount"
              >
                <el-input
                  style="width: 130px"
                  onkeyup="value=value.replace(/[^\d.]/g,'')"
                  v-model="scope.row.concAmount"
                  oninput="value=value.replace(/^\D*(\d{1,12}(?:\.\d{0,8})?).*$/g, '$1')"
                  placeholder="请输入"
                  clearable
                  maxlength="21"
                />
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column width="150px" prop="remark" label="工程业绩">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.cooPfeInfo`"
                :rules="tableRules.cooPfeInfo"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.cooPfeInfo"
                  placeholder="请输入"
                  clearable
                  maxlength="1000"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="remark" label="工程数量">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.attribute2`"
                :rules="tableRules.attribute2"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.attribute2"
                  placeholder="请输入"
                  clearable
                  @input="scope.row.attribute2=scope.row.attribute2.replace(/^(0+)|[^\d]+/g,'')"
                  maxlength="128"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="remark" label="合同工期（天）">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.contractDuration`"
                :rules="tableRules.contractDuration"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.contractDuration"
                  placeholder="请输入"
                  clearable
                  maxlength="4"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px"  label="专业级别">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.subjectTopName`"
                :rules="tableRules.subjectTopName"
              >
                <el-input
                  style="width: 130px"
                  @click.native="getScope(scope)"
                  v-model="scope.row.subjectTopName"
                  placeholder="请选择"
                  maxlength="18"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="remark" label="甲方证明人">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.firstPartyWitness`"
                :rules="tableRules.firstPartyWitness"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.firstPartyWitness"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                />
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column width="150px" prop="remark" label="甲方证明人电话">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.witnessPhone`"
                :rules="tableRules.witnessPhone"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.witnessPhone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="remark" label="现场负责人">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.teamLeader`"
                :rules="tableRules.teamLeader"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.teamLeader"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="remark" label="负责人电话">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extForm.${scope.$index}.teamLeaderPhone`"
                :rules="tableRules.teamLeaderPhone"
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.teamLeaderPhone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="remark" label="其他">
            <template slot-scope="scope">
              <el-form-item
              >
                <el-input
                  style="width: 130px"
                  v-model="scope.row.extInfo"
                  placeholder="请输入"
                  clearable
                  maxlength="255"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="附件" width="180">
            <!-- :http-request="(file)=>{return imggreySuccess(file ,scope.row)}" -->
            <template slot-scope="scope">
              <!-- evidenceFile -->
              <!-- {{getUrl(scope)}} -->
              <el-upload
                :file-list="scope.row.fileList"
                :limit="1"
                :on-success="handleSuccess"
                :action="importFileUrl"
                :on-exceed="handleExceed"
                :on-remove="handleRemove"
              >
                <!-- :show-file-list="false" -->
                <!-- list-type="text" -->
                <span
                  v-if="uploaded"
                  style="font-size:7px;padding:3px 10px;border-radius:5px;color:white;background:red;"
                  >上传</span
                >
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
              </el-upload>
            </template>
          </el-table-column>
          <el-table-column fixed="right" prop="remark" label="操作">
            <template slot-scope="scope">
              <span
                @click="deleteItem(scope)"
                style="cursor: pointer;color: red"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label-width="0px" label="">
        <div class="addBtn" @click="addTable()">+添加业绩</div>
      </el-form-item>
      <el-form-item label-width="350px">
        <el-button @click="submitForm('ruleForm')">下一步</el-button>
        <el-button class="stopBtn" @click="saveForm('ruleForm')">暂存</el-button>
        <el-button class="lastBtn" @click="lastStep('ruleForm')"
          >上一步</el-button
        >
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择专业"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <el-tree
        @node-click="handleNodeClick"
        node-key="dicValue"
        :props="props"
        :load="loadNode"
        :default-expanded-keys="[1]"
        draggable
        lazy
      >
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getTreeItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  registerSubconChangeInfo,
  getStairMajor
} from "@/api/subcontractor-register";
export default {
  props: {
    fourthStepId: "",
    extForm: {
      type: Array,
      default: () => {
        return [];
      }
    },
    extForm1: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      uploaded:true,
      centerDialogVisible: false,
      subData: [],
      subId: "",
      nodeName: "",
      nodeId: "",
      props: {
        label: "name",
        children: "zones",
        isLeaf: "leaf"
      },
      imggrey: [],
      currentId: "",
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL) +
        "/apis/sra/reg/users/signup/uploadFileToOss", // 上传地址 // 上传地址
      /*importFileUrl:
        "http://uat01-sra.iccec.cn/apis/sra/reg/users/signup/uploadFileToOss",*/ formLoading: false,
      form: {},
      tableRules: {
        firstParty: [
          //{ required: true, message: "请输入甲方证明人", trigger: "blur" }
          /*{
            required: false,
            pattern: /^[\u4e00-\u9fa5]{2,50}$/,
            message: "请输入2-18个中文汉字"
          }*/
        ],
        zjInternalExternal: [
          { required: true, message: "请输入中交内外部", trigger: "blur" }
        ],
        cooPfeInfo: [
          { required: true, message: "请输入工程业绩", trigger: "blur" },
          /*{
            required: false,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数"
          }*/
        ],
        concAmount: [
          { required: true, message: "请输入合同金额", trigger: "blur" },
        ],

        concName: [
          { required: true, message: "请输入合同名称", trigger: "blur" }
        ],
        attribute2: [
          { required: true, message: "请输入工程数量", trigger: "blur" },
          /*{
            pattern: /^[0-9]*$/,
            message: "请输入2-4个中文汉字"
          }*/
        ],
        contractDuration: [
          { required: true, message: "请输入合同工期", trigger: "blur" },
          {
            required: false,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数"
          }
        ],
        firstPartyWitness: [
          { required: true, message: "请输入甲方证明人", trigger: "blur" },
          // {
          //   required: false,
          //   pattern: /^[\u4e00-\u9fa5]{2,18}$/,
          //   message: "请输入2-18个中文汉字"
          // }
        ],
        witnessPhone: [
          { required: true, message: "请输入甲方证明人电话", trigger: "blur" },
          {
            pattern: /^\d{11}$/,
            message: "手机号码输入错误"
          }
        ],
        teamLeader: [
          { required: true, message: "请输入现场负责人", trigger: "blur" },
          // {
          //   required: false,
          //   pattern: /^[\u4e00-\u9fa5]{2,18}$/,
          //   message: "请输入2-18个中文汉字"
          // }
        ],
        teamLeaderPhone: [
          { required: true, message: "请输入班组长电话", trigger: "blur" },
          {
            pattern: /^\d{11}$/,
            message: "手机号码输入错误"
          }
        ],
        subjectTopName: [
          { required: true, message: "请输入专业", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5]{2,18}$/,
            message: "专业输入错误"
          }
        ],
        extInfo: [
          { required: true, message: "请输入其他信息", trigger: "blur" }
        ]
        // deviceName: [
        //   { required: true, message: "请输入设备名称", trigger: "blur" },
        //   {
        //     pattern: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/,
        //     message: "只支持中文、英文、数字",
        //   },
        // ],
      }
    };
  },
  mounted() {
    //     <!--
    //      *@Description:修改上传图片颤抖bug
    //      * @Author:zhoutao
    //      * @Date: 2021-11-02
    //  -->
    this.extForm.forEach(e => {
      let fileList = [];
      let obj = {};
      if (e.attribute10 && typeof e.attribute10 == "string") {
        if (e.attribute10) {
          e.evidenceFile = JSON.parse(e.attribute10);
          obj.name = JSON.parse(e.attribute10).fileName;
          obj.url = JSON.parse(e.attribute10).downloadUrl;
          fileList.push(obj);
          e.fileList = fileList;
        }
      } else {
        if (e.attribute10) {
          e.evidenceFile = e.attribute10;
          obj.name = e.attribute10.fileName;
          obj.url = e.attribute10.downloadUrl;
          fileList.push(obj);
          e.fileList = fileList;
        }
      }
    });
  },
  methods: {
    getUrl(scope) {
      if (scope.row.attribute10 && typeof scope.row.attribute10 == "string") {
        scope.row.evidenceFile = JSON.parse(scope.row.attribute10);
        return [
          {
            name: JSON.parse(scope.row.attribute10).fileName,
            url: JSON.parse(scope.row.attribute10).downloadUrl
          }
        ];
      } else if (
        scope.row.attribute10 &&
        typeof scope.row.attribute10 == "object"
      ) {
        scope.row.evidenceFile = scope.row.attribute10;
        return [
          {
            name: scope.row.attribute10.fileName,
            url: scope.row.attribute10.downloadUrl
          }
        ];
      }
    },
    handleNodeClick(data, node, b) {
      this.nodeName = data.name;
      this.nodeId = data.id;
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        getStairMajor({}).then(res => {
          if (res.data.code == "0") {
            this.subData = res.data.data;
            return resolve(this.subData);
          }
        });
      }
      if (node.level > 1) return resolve([]);
      setTimeout(() => {
        resolve([]);
      }, 0);

    },
    getScope(scope) {
      this.subId = scope.$index;
      this.centerDialogVisible = true;
    },
    getTreeItem() {
      if (!this.nodeName) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择节点数据",
          ccuiCustom: true
        });
        return false;
      } else {
        this.$set(
          this.extForm[this.subId],
          "subjectTopName",
          this.nodeName
        );
        this.$set(
          this.extForm[this.subId],
          "subjectTopId",
          this.nodeId
        );
        this.centerDialogVisible = false;
      }
    },
    getRow(row, column, event) {
      this.currentId = row.id;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleRemove(file, fileList) {
      this.uploaded=true
      this.extForm.forEach(item => {
        if (this.currentId === item.id) {
          this.$set(item, "evidenceFile", "");
          this.$set(item, "attribute10", "");
          delete item.fileList;
        }
      });
    },
    handleSuccess(response, file) {
      this.extForm.forEach(item => {
        if (this.currentId === item.id) {
          this.$set(item, "evidenceFile", response.data[0]);
          this.$set(item, "attribute10", response.data[0]);
        }
      });
      this.uploaded=false
    },
    // 新增
    addTable() {
      if (this.extForm && this.extForm.length === 0) {
        this.extForm.push({
          id: 1
        });
      } else {
        this.extForm.push({
          id: this.extForm[this.extForm.length - 1].id + 1
        });
      }
    },
    // 删除当前项
    deleteItem(scope) {
      this.extForm.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extForm.splice(index, 1);
        }
      });
    },
    saveForm(formName) {
      var qualificationListTmp = [];
      if (this.extForm && this.extForm.length > 0) {
        this.extForm.forEach(e => {
          var tmp = Object.assign({}, e);
          tmp.createTime = "";
          tmp.updateTime = "";
          tmp.attribute10 = "";
          tmp.evidenceFile = tmp.evidenceFile ? tmp.evidenceFile.uploadId : "";
          tmp.yesNo = tmp.yesNo === "是" ? 0 : 1;
          qualificationListTmp.push(tmp);
        });
      }
      this.formLoading = true;
      var that = this;
      if(qualificationListTmp.length===0){
        this.$message({
          showClose: true,
          type: "warning",
          message: "合作业绩不能为空",
          ccuiCustom: true
        });
        this.formLoading = false;
      } else {
        registerSubconChangeInfo({
          subconChangeInfo: {
            id: that.fourthStepId,
            country: that.extForm1.country,
            province: that.extForm1.province,
            city: that.extForm1.city,
            county: that.extForm1.county,
            attribute2: that.extForm1.attribute2
          },
          subconCooPfeChange: qualificationListTmp
        }).then(
          res => {
            this.formLoading = false;
            if (res.data.data.code === "0") {
              this.$message({
                showClose: true,
                type: "success",
                message: "暂存成功",
                ccuiCustom: true
              });
            } else {
              this.$message({
                showClose: true,
                type: "error",
                message: res.data.data.message,
                ccuiCustom: true
              });
            }
          },
          error => {
            this.formLoading = false;
          }
        );
      }
    },
    submitForm(formName) {
      var qualificationListTmp = [];
      if (this.extForm && this.extForm.length > 0) {
        this.extForm.forEach(e => {
          var tmp = Object.assign({}, e);
          tmp.createTime = "";
          tmp.updateTime = "";
          tmp.attribute10 = "";
          tmp.evidenceFile = tmp.evidenceFile ? tmp.evidenceFile.uploadId : "";
          qualificationListTmp.push(tmp);
        });
      }
      var that = this;
      this.$refs["extForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          if(qualificationListTmp.length===0){
            this.$message({
              showClose: true,
              type: "error",
              message: "合作业绩不能为空",
              ccuiCustom: true
            });
            this.formLoading = false;
          } else {
            registerSubconChangeInfo({
              subconChangeInfo: {
                id: that.fourthStepId,
                country: that.extForm1.country,
                province: that.extForm1.province,
                city: that.extForm1.city,
                county: that.extForm1.county,
                attribute2: that.extForm1.attribute2,
                registeredType: 0,
                checkState: 1
              },
              subconCooPfeChange: qualificationListTmp
            }).then(
              res => {
                this.formLoading = false;
                if (res.data.data.code === "0") {
                  this.$emit("getStep", 4);
                }
              },
              error => {
                this.formLoading = false;
              }
            );
          }
        } else {
          this.$message({
            showClose: true,
            type: "error",
            message: "请完善合作业绩信息",
            ccuiCustom: true
          });
          return false;
        }
      });
    },
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-table td {
  padding: 0 !important;
}
.demo-ruleForm {
  /deep/ .el-table__fixed {
    height: 100% !important; //设置高优先，以覆盖内联样式
  }
}
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/

  // width: 100%;
  // position: relative;
  // .demo-ruleForm {
  //   position: absolute;
  //   left: 50%;
  //   transform: translate(-50%, 0);
  // }
}
.el-form-item__content .el-button {
  width: 82px;
  height: 40px;
  background: #ff152e;
  border-radius: 2px;
  font-size: 14px;
  border: none;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.el-form-item__content .stopBtn {
  background: rgba(255, 21, 46, 0.08);
  border: 1px solid #ff152e;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff152e;
}
.el-form-item__content .lastBtn {
  background: #fafafa;
  border: 1px solid #dddddd;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
}
.addBtn {
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
.el-table /deep/.has-gutter tr th:nth-child(-n+13) :before{
  content: "*";
  color: red;
  margin-right: 5px;
}


.addTabIndex /deep/.el-form-item__content {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 55px !important;
  }
  thead tr th {
    background: #fafafa;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }
}
/deep/.el-tree-node__content>.el-tree-node__expand-icon {
  padding: 6px;
  display: none !important;
}
.fourthStep /deep/.el-form-item__error{
  position: static!important;
}
</style>
